// export const API_URL = "http://localhost:5000";
export const API_URL = "https://api.nakshatranamahacreations.in";